import { ChangeEvent, FC } from "react";

import { Box, VStack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Checkbox from "@components/Checkbox";
import Icon from "@components/Icon";

import { InvoiceType, OrderFields } from "../../../constants";
import useOrderFormik from "../../../hooks/useOrderFormik";
import OrderInfoItem from "../OrderInfoItem";
import InvoiceCompanyForm from "./InvoiceCompanyForm";
import InvoicePrivateForm from "./InvoicePrivateForm";

const OrderInfoInvoice: FC = () => {
  const { t } = useTranslation();

  const {
    values: { [OrderFields.INVOICE_TYPE]: invoiceType },
    setFieldValue,
  } = useOrderFormik();

  const handleInvoiceTypeChange = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    setFieldValue(OrderFields.INVOICE_TYPE, checked ? InvoiceType.COMPANY : InvoiceType.PRIVATE);
  };

  const invoiceDescription = (
    <VStack spacing="0.5rem" align="start">
      {invoiceType === InvoiceType.PRIVATE && <InvoicePrivateForm />}
      <Box>
        <Checkbox isFormik={false} isChecked={invoiceType === InvoiceType.COMPANY} onChange={handleInvoiceTypeChange}>
          {t("order-summary-want_invoice_for_company")}
        </Checkbox>
      </Box>
    </VStack>
  );

  return (
    <>
      <OrderInfoItem
        id="order-package-size"
        title={t("order-summary-invoice")}
        description={invoiceDescription}
        isFixedWidthTitle
        isTopAlignedTitle
        image={<Icon icon="export" size="1.75rem" />}
        isEditHidden
      />
      {invoiceType === InvoiceType.COMPANY && <InvoiceCompanyForm />}
    </>
  );
};
export default OrderInfoInvoice;
